import axios from 'axios'
const isEqual = require('lodash.isequal')

export function ucfirst(text) {
    return text.charAt(0).toUpperCase() + text.substr(1)
}

export function importComponents(files, except = []) {
    const components = {}

    files
        .keys()
        .filter((file) => file.split('/').length === 2) // Ignore nested components.
        .forEach((file) => {
            const component = file.replace(/(\.\/|\.vue)/g, '')

            if (except.includes(component)) {
                return
            }

            components[component] = files(file).default
        })

    return components
}

export function simulateApiCall(response, maxTime = 1000) {
    return new Promise((resolve) => setTimeout(() => resolve(response), Math.floor(Math.random() * maxTime) + maxTime / 10))
}

export function isRouteNameEqual(firstRouteName, secondRouteName, comparisonDepth = 1) {
    const firstRouteChunks = firstRouteName ? firstRouteName.split('.').slice(0, comparisonDepth) : ['']
    const secondRouteChunks = secondRouteName ? secondRouteName.split('.').slice(0, comparisonDepth) : ['']
    return firstRouteChunks.join('.') === secondRouteChunks.join('.')
}

export function matchFullRoute(targetRoute, currentRoute, comparisonDepth = 1) {
    if (!targetRoute.params && Object.keys(currentRoute.params).length === 0 && currentRoute.params.constructor === Object) {
        return isRouteNameEqual(targetRoute.name, currentRoute.name, comparisonDepth) || targetRoute.path === currentRoute.path
    }
    return (
        isRouteNameEqual(targetRoute.name, currentRoute.name, comparisonDepth) && isEqual(targetRoute.params, currentRoute.params)
    )
}

export function isSubdomainActive() {
    const urlComponents = window.location.host.split('.')
    if (urlComponents.length <= 2 && !(urlComponents.length === 2 && urlComponents[1].includes('localhost'))) {
        return false
    }
    const ignoreSubdomains = process.env.VUE_APP_IGNORE_SUBDOMAINS.split(',')
    return !ignoreSubdomains.includes(urlComponents[0])
}

export function dateFormat(date) {
    const [year, month, day] = date.split('-')
    return new Date(year, month - 1, day)
}

export function setMetaTitle(title) {
    document.head.querySelector('meta[property="og:title"]').content = title
}

export function setMetaDescription(description) {
    document.head.querySelector('meta[property="og:description"]').content = description
}

export function setSiteTitle(title) {
    document.title = title
}

export function getSocialMediaURL(data, socialMediaPaths, SocialMediaEnums) {
    const socialMediaPlatforms = Object.values(SocialMediaEnums)

    socialMediaPlatforms.forEach((smp) => {
        if (data[smp]) {
            socialMediaPaths[smp] = data[smp].startsWith('https') ? data[smp] : `https://${data[smp]}`
        } else {
            socialMediaPaths[smp] = null
        }
    })
    return socialMediaPaths
}

export async function isLocalTimeRight() {
    let serverTime
    return axios.get('/server-time').then((res) => {
        serverTime = new Date(res.serverTime)
        const timeDifference = Math.abs(serverTime - new Date())
        return timeDifference > 60000
    })
}

export function cyrillicToLatin(text) {
    const map = {
        А: 'A',
        Б: 'B',
        В: 'V',
        Г: 'G',
        Д: 'D',
        Ђ: 'Đ',
        Е: 'E',
        Ж: 'Ž',
        З: 'Z',
        И: 'I',
        Ј: 'J',
        К: 'K',
        Л: 'L',
        Љ: 'Lj',
        М: 'M',
        Н: 'N',
        Њ: 'Nj',
        О: 'O',
        П: 'P',
        Р: 'R',
        С: 'S',
        Т: 'T',
        Ћ: 'Ć',
        У: 'U',
        Ф: 'F',
        Х: 'H',
        Ц: 'C',
        Ч: 'Č',
        Џ: 'Dž',
        Ш: 'Š',
        а: 'a',
        б: 'b',
        в: 'v',
        г: 'g',
        д: 'd',
        ђ: 'đ',
        е: 'e',
        ж: 'ž',
        з: 'z',
        и: 'i',
        ј: 'j',
        к: 'k',
        л: 'l',
        љ: 'lj',
        м: 'm',
        н: 'n',
        њ: 'nj',
        о: 'o',
        п: 'p',
        р: 'r',
        с: 's',
        т: 't',
        ћ: 'ć',
        у: 'u',
        ф: 'f',
        х: 'h',
        ц: 'c',
        ч: 'č',
        џ: 'dž',
        ш: 'š',
    }

    return text
        .split('')
        .map((char) => map[char] || char)
        .join('')
}
